import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL


class SiteSettingsApi {
    serviceMaintenance( data, config) {
        return axios.put(`${BASE_URL}/admin/site-configuration/serviceMaintenance`, data, config)
    }
    getServiceMaintenance(config) {
        return axios.get(`${BASE_URL}/admin/site-configuration/serviceMaintenance`, config)
    }
    updateOtpExpiry(data, config) {
        return axios.put(`${BASE_URL}/admin/site-configuration/updateOtpExpiry`, data, config)
    }
    getOtpDetails(config) {
        return axios.get(`${BASE_URL}/admin/site-configuration/getOtpDetails`, config)
    }
    updateAllStudentsIsAgeTeen(config) {
        return axios.post(`${BASE_URL}/admin/attention/updateAllStudentsIsAgeTeen`, config)
    }
    updatePrivacyPolicy(data, config) {
        return axios.put(`${BASE_URL}/admin/site-configuration/updatePrivacyPolicy`, data, config)
    }
    getPrivacyPolicy(config) {
        return axios.get(`${BASE_URL}/admin/site-configuration/getPrivacyPolicy`, config)
    }
    updateTermsOfService(data, config) {
        return axios.put(`${BASE_URL}/admin/site-configuration/updateTermsOfService`, data, config)
    }
    getTermsOfService(config) {
        return axios.get(`${BASE_URL}/admin/site-configuration/getTermsOfService`, config)
    }
}

const siteSettingsApi = new SiteSettingsApi()
export default siteSettingsApi
